import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type WithoutChild<T> = T extends { child?: any } ? Omit<T, 'child'> : T;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type WithoutChildren<T> = T extends { children?: any }
	? Omit<T, 'children'>
	: T;
export type WithoutChildrenOrChild<T> = WithoutChildren<WithoutChild<T>>;
export type WithElementRef<T, U extends HTMLElement = HTMLElement> = T & {
	ref?: U | null;
};

/** Returns a hex colour matching the grade letter (A–F). */
export function gradeColor(grade: string | null | undefined): string {
	switch (grade) {
		case 'A+':
		case 'A':
		case 'A-':
			return '#059669';
		case 'B+':
		case 'B':
		case 'B-':
			return '#10b981';
		case 'C+':
		case 'C':
			return '#eab308';
		case 'D':
			return '#f97316';
		default:
			return '#ef4444';
	}
}

/** Returns a Tailwind bg+text class string for a grade pill. */
export function gradeClasses(grade: string | null | undefined): string {
	switch (grade) {
		case 'A+':
		case 'A':
		case 'A-':
			return 'bg-emerald-600 text-white';
		case 'B+':
		case 'B':
		case 'B-':
			return 'bg-emerald-400 text-white';
		case 'C+':
		case 'C':
			return 'bg-yellow-400 text-black';
		case 'D':
			return 'bg-orange-400 text-white';
		default:
			return 'bg-red-500 text-white';
	}
}
